import * as React from 'react';

export const useLazyRef = <T>(getRef: () => T) => {
  const ref = React.useRef<T | null>(null);

  if (!ref.current) {
    ref.current = getRef();
  }

  return ref as Readonly<React.MutableRefObject<T>>;
};
